



















import { Component, Vue, Prop } from "vue-property-decorator";
import HalfNumbersConverter from "@/helpers/HalfNumbersConverter";
import Decimal from "decimal.js";

const converter = new HalfNumbersConverter();

@Component({})
export default class VInputNumber extends Vue {
  @Prop() name?: string;
  @Prop() placeholder?: string;
  @Prop() size?: string;
  @Prop() plaintext?: boolean;
  @Prop() min?: number;
  @Prop() max?: number;
  @Prop() step?: number;
  @Prop({ required: true }) value!: number;
  @Prop({ type: Boolean }) required?: boolean;
  @Prop({ type: Boolean, default: true }) autoselect?: boolean;

  input(value: string) {
    this.$emit("input", this.validate(converter.convert(value)));
  }

  change(value: string) {
    this.$emit("change", this.validate(converter.convert(value)));
  }

  focus() {
    if (!this.autoselect) return;
    const target = this.$refs["control"] as HTMLInputElement;
    target.select();
  }

  private validate(value: string) {
    const target = this.$refs["control"] as HTMLInputElement;
    // clear
    target.setCustomValidity("");
    const n = Number(value);
    if (isNaN(n)) return value;
    // min
    if (this.min && !isNaN(this.min) && Number(this.min) > n) {
      target.setCustomValidity(`値は ${this.min} 以上にする必要があります。`);
      return value;
    }
    // max
    if (this.max && !isNaN(this.max) && Number(this.max) < n) {
      target.setCustomValidity(`値は ${this.max} 以下にする必要があります。`);
      return value;
    }
    // step
    if (this.step && !isNaN(this.step) && !Decimal.mod(n, this.step).eq(0)) {
      target.setCustomValidity(
        `最小単位は ${this.step} です。値は ${this.step} で割り切れる必要があります。`
      );
      return value;
    }
    return value;
  }
}
